import styled, { css, keyframes } from 'styled-components';

interface IIconWrapper {
	rotating: boolean;
}

export const rotate = keyframes`
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;
export const SimpleButton = styled.button`
	border-radius: 2px;
	width: 100%;
	display: flex;
	align-items: center;
	border: none;
	cursor: pointer;
	margin-bottom: 8px;
	padding: 10px;
`;

export const Input = styled.input`
	height: 48px;
	background: ${({ theme }) => theme.color.porcelainSecond};
	border-radius: 2px;
	border: none;
	width: 100%;
	box-sizing: border-box;
	padding: 0 16px;
	color: ${({ theme }) => theme.color.ebony};
	margin-bottom: 16px;
	font-size: 16px;

	&::placeholder {
		color: ${({ theme }) => theme.color.osloGrey};
		opacity: 1;
	}

	&:-ms-input-placeholder {
		color: ${({ theme }) => theme.color.osloGrey};
	}

	&::-ms-input-placeholder {
		color: ${({ theme }) => theme.color.osloGrey};
	}

	&:focus-visible {
		outline: none;
		background-color: ${({ theme }) => theme.color.spindle};
	}

	&:disabled {
		background-color: ${({ theme }) => theme.color.porcelain};
		color: ${({ theme }) => theme.color.casper};
		cursor: not-allowed;
	}
`;
export const H4Styled = styled.h4`
	cursor: pointer;
	user-select: none;
	${({ theme }) => theme.mixin.subtitle()};
`;

export const Spacer = styled.div`
	display: flex;
	width: 100%;
	margin-top: 12px;
	margin-bottom: 12px;
	height: 1px;
	background-color: ${({ theme }) => theme.color.porcelain};
`;
export const IconWrapper = styled.span<IIconWrapper>`
    display: flex;
    width: 22px;
    ${({ rotating }) =>
		rotating &&
		css`
			animation: ${rotate} 2s linear infinite;
		`}
    };
    svg, img {
        width: 100%;
    }
`;
